import { createApp } from 'vue'
import i18n from './i18n'
import {
  createVuesticEssential,
  VaButton,
  VaSelect,
  VaInput,
  VaDropdownPlugin,
  VaDataTable,
  VaBadge,
  VaIcon,
  VaSidebar,
  VaDropdownContent,
  VaButtonToggle,
  VaSidebarItem,
  VaTab,
  VaTabs,
  VaCard,
  VaCardContent,
  VaModal,
  VaTimeInput,
  VaCheckbox,
  VaChip,
  VaNavbar,
  VaNavbarItem,
  VaAccordion,
  VaCollapse,
  VaModalPlugin,
  VaSidebarItemTitle,
  VaSidebarItemContent,
  VaForm,
  VaDropdown,
  VaListItem,
  VaAlert,
  VaSkeleton,
} from 'vuestic-ui'
import 'vuestic-ui/styles/essential.css'
import { createGtm } from '@gtm-support/vue-gtm'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'

const app = createApp(App)

app.use(VueGoogleMaps, {
  load: {
    key: import.meta.env.VITE_GOOGLE_MAP_API_KEY,
    libraries: 'places,marker',
    loading: 'async',
    v: 'weekly',
  },
})
app.use(stores)
app.use(router)
app.use(i18n)
app.use(
  createVuesticEssential({
    components: {
      VaButton,
      VaSelect,
      VaInput,
      VaDataTable,
      VaBadge,
      VaIcon,
      VaSidebar,
      VaDropdownContent,
      VaButtonToggle,
      VaSidebarItem,
      VaSidebarItemContent,
      VaSidebarItemTitle,
      VaTab,
      VaTabs,
      VaCard,
      VaCardContent,
      VaModal,
      VaTimeInput,
      VaCheckbox,
      VaChip,
      VaNavbar,
      VaNavbarItem,
      VaAccordion,
      VaCollapse,
      VaForm,
      VaDropdown,
      VaListItem,
      VaAlert,
      VaSkeleton,
    },
    plugins: { VaDropdownPlugin, VaModalPlugin },
    config: {
      ...vuesticGlobalConfig,
      /* ... */
    },
  }),
)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
